import Heading from "../../../../src/components/heading";
import Subheading from "../../../../src/components/subheading";
import AboutImage from "../../../../src/components/about-image";
import ImageWrapper from "../../../../src/components/image-wrapper";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import SEO from "../../../../src/components/seo";
import React from 'react';
export default {
  Heading,
  Subheading,
  AboutImage,
  ImageWrapper,
  graphql,
  Img,
  SEO,
  React
};